/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceManagementAction {
    getFixupPrototypeFunction() { return ResourceManagementAction.fixupPrototype; }

    static newInstance(model: Partial<ResourceManagementAction>): ResourceManagementAction {
        let obj = Object.assign(new ResourceManagementAction(), model);
        ResourceManagementAction.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceManagementAction>): ResourceManagementAction {
        if (!model) return null;
        return ResourceManagementAction.newInstance(<ResourceManagementAction> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceManagementAction) {
        if (!obj) return;

        models.ResourceManagementAction.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceManagementAction): boolean {
        Object.setPrototypeOf(obj, ResourceManagementAction.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.template_params) {
            for (let val of this.template_params) {
                models.ResourceTemplateParam.fixupPrototype(val);
            }
        }
    }

    /**
     * Action identifier, for example Delete or Manage_Tags
     */
    name: string;

    /**
     * Display label master data gives the action instead of its identifier, for example Manage Labels for GCP's Manage_Tags. Absent when the identifier is the label
     */
    alias_name: string;

    /**
     * How the action is carried out. Swagger calls the provider directly, Template runs a CoreStack template, Tags edits tags
     */
    action_type: models.ResourceActionType;

    /**
     * Whether master data asks for the action to be confirmed before it runs
     */
    action_confirmation: boolean;

    /**
     * Human-readable description of what the action does
     */
    activity_description: string;

    /**
     * Automation template a Template action runs. Absent for other action types
     */
    template_name: string;

    /**
     * Identifier of that template in the caller's tenant. Absent when the template is not installed there
     */
    template_id: string;

    /**
     * Template inputs and the record paths they are filled from
     */
    template_params: Array<models.ResourceTemplateParam>;

    /**
     * Provider operation a Swagger action calls, for example StopInstances. Absent for other action types
     */
    operation_id: string;

}
